import { SortOrder } from "shared/types/SortOrder"

import { ProjectSortKey } from "entities/projects/model/useProjectSorting"
import { map } from "nanostores"
import { ProjectsFilterFormData } from "pages/projects-overview-page/schema/projectsFilterFormDataSchema"

const defaultState: ProjectsFilterFormData = {
  projectPhase: null,
  searchTerm: null,
  sort: `${ProjectSortKey.UPDATED_AT}:${SortOrder.DESC}`
}

// Deliberately not persisted, see portfolio-filter-store.
export const projectsOverviewFilterStore =
  map<ProjectsFilterFormData>(defaultState)

export function setProjectsOverviewFilters(state: ProjectsFilterFormData) {
  projectsOverviewFilterStore.set(state)
}
